import gql from 'graphql-tag';

const UPSERT_CAMPAIGN_ORDER_ATTACHMENT = gql`
  mutation UpsertCampaignOrderAttachment(
    $campaignOrderId: String!
    $documentInfo: JSON!
    $s3Key: String!
    $externalCRMIntegrationId: String
  ) {
    upsertCampaignOrderAttachment(
      campaignOrderId: $campaignOrderId
      documentInfo: $documentInfo
      s3Key: $s3Key
      externalCRMIntegrationId: $externalCRMIntegrationId
    )
  }
`;

export default UPSERT_CAMPAIGN_ORDER_ATTACHMENT;
